import { defineFeature } from '@/lib/platform/system';
import { busTimesMachine } from '@/features/bus-times/state/bus-times.machine';

export const features = [
  defineFeature({
    id: 'bus-times',
    machine: busTimesMachine,
    emits: [
      'bus-times.route-chosen',
      'bus-times.direction-chosen',
      'bus-times.stop-chosen',
      'bus-times.schedule-viewed',
      'bus-times.schedule-refreshed',
    ],
    handles: [],
    accepts: [
      'bus-times.choose-route',
      'bus-times.choose-direction',
      'bus-times.choose-stop',
      'bus-times.view-schedule',
      'bus-times.refresh-schedule',
    ],
  }),
] as const;
